import * as _ from 'lodash'
import { required, helpers } from 'vuelidate/lib/validators'
import Api from '@/providers/Api'

/**
 * Model "class" for Biometrics - defines useful field metadata for building and validating forms
 */

const maxLengthIfNonEmpty = (value) => {
    return !helpers.req(value) || value.length <= 255
}

export default {
    fields: {
        participant_id: {
            label: 'FIELD_PATIENT',
            type: 'typeahead',
            placeholder: 'FIELD_PATIENT_PLACEHOLDER',
            getFieldObject: (biometric) => {
                return biometric.participant
            },
            typeaheadToString: (participant) => {
                if (participant) {
                    return `${participant.fullname} ${participant.dob} ${participant.email}`
                } else {
                    return ''
                }
            },
            doTypeaheadSearch: (vue, modelInstance, searchText) => {
                return vue.$api.findPatients(vue, vue.$user.practitionerPracticeId(), searchText)
            },
        },
        external_id: {
            label: 'FIELD_EXTERNAL_ID',
            type: 'text',
            validations: { maxLengthIfNonEmpty: 255 },
            invalidFeedback: { required: 'MESSAGE_FIELD_REQUIRED' }
        },
        tchol: {
            label: 'FIELD_BIOMETRICS_TCHOL',
            type: 'number',
        },
        ldl_c: {
            label: 'FIELD_BIOMETRICS_LDL',
            type: 'number',
        },
        hdl_c: {
            label: 'FIELD_BIOMETRICS_HDL',
            type: 'number',
        },
        trig: {
            label: 'FIELD_BIOMETRICS_TRIG',
            type: 'number',
        },
        fasting_bg: {
            label: 'FIELD_BIOMETRICS_FBG',
            type: 'number',
        },
        a1c: {
            label: 'A1C',
            noLabelTranslation: true,
            type: 'number',
            step: .1,
        },
        comment: {
            label: 'FIELD_COMMENT',
            type: 'text',
        },
    }
}
